import { SnackbarSeverity } from 'constant'
import { createContext, ReactNode, useState } from 'react'

interface SnackContext {
  snackbarAttributes: any
  setSnackbarAttributes: (snackbarAttributes: any) => void
  handleOpenSnackbar: (severity: SnackbarSeverity, message: string) => void
  handleCloseSnackbar: () => void
}
export const SnackContext = createContext<SnackContext>({
  snackbarAttributes: {
    open: false,
    severity: SnackbarSeverity.Success,
    message: '',
    duration: 5000
  },
  setSnackbarAttributes: () => {},
  handleOpenSnackbar: () => {},
  handleCloseSnackbar: () => {}
})
interface Props {
  children: ReactNode
}

const SnackContextProvider = ({ children }: Props) => {
  const [snackbarAttributes, setSnackbarAttributes] = useState({
    open: false,
    severity: 'success',
    message: '',
    duration: 5000
  })
  const handleOpenSnackbar = (
    severity: SnackbarSeverity,
    message: string,
    duration: number = 5000
  ) => {
    setSnackbarAttributes({
      ...snackbarAttributes,
      open: true,
      severity,
      message,
      duration
    })
  }
  const handleCloseSnackbar = () => {
    setSnackbarAttributes({ ...snackbarAttributes, open: false })
  }
  return (
    <SnackContext.Provider
      value={{
        snackbarAttributes,
        setSnackbarAttributes,
        handleOpenSnackbar,
        handleCloseSnackbar
      }}
    >
      {children}
    </SnackContext.Provider>
  )
}

export default SnackContextProvider
